import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import React, { useEffect, useState } from 'react';
import globalPaymentServices from '../../../../../stores/global-payment-services';
import { PaymentServiceWithVersionsResponseType } from '../../../../../api/types/payments/payment-template';
import { Chip } from 'primereact/chip';
import CancelButton from '../../../../../component/ui/buttons/cancel-button/cancel-button';
import ApproveButtons from '../../../../../component/ui/buttons/approve-button/approve-buttons';
import { createNewServiceOperation } from '../operations/create-new-service-operation';
import globalProgramStore from '../../../../../stores/program-store';
import globalConfigStore from '../../../../../stores/global-config-store';
import appApi from '../../../../../api/app-api';
import { observer } from 'mobx-react-lite';

interface AddNewServiceToProgramModel {
  closeDialog: () => void;
  selectedYear: number;
}

export const DialogAddNewServiceToProgram: React.FC<AddNewServiceToProgramModel> =
  observer(({ selectedYear, closeDialog }) => {
    const [selectedService, setSelectedService] = useState<
      PaymentServiceWithVersionsResponseType[]
    >([]);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
      const fetchPaymentServices = async () => {
        const asd = await appApi.getAllPaymentServices();
        globalPaymentServices.services = asd.data.body;
      };
      fetchPaymentServices();
    }, []);

    const handleApprove = async () => {
      const branchId = globalConfigStore.rootFilter.currentBranches?.id;
      const selectedServicesIds = selectedService.map((item) => item.id);
      await createNewServiceOperation(
        branchId,
        globalProgramStore.getCurrentId(),
        selectedYear,
        selectedServicesIds,
        setLoading,
        closeDialog,
      );
    };

    return (
      <div>
        <DataTable
          emptyMessage={
            <div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>
          }
          selectionMode={'multiple'}
          multiple={true}
          groupRowsBy="dsf"
          value={globalPaymentServices.services}
          selection={selectedService}
          onSelectionChange={(e) => {
            setSelectedService(
              e.value as PaymentServiceWithVersionsResponseType[],
            );
          }}
          dataKey="id"
          tableStyle={{
            direction: 'rtl',
            marginTop: '16px',
          }}
        >
          <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
          <Column
            style={{ textAlign: 'right', width: '3rem' }}
            field="paymentServiceName"
            header="שם שרות"
          />
          <Column field="lastName" header="" style={{ textAlign: 'right' }} />
          <Column
            body={(data, options) => (
              <div>
                {JSON.stringify(data.versions[data.versions.length - 1].price)}
              </div>
            )}
            header="מחיר"
            style={{ textAlign: 'right' }}
          />
          <Column
            field="createdByName"
            header="נוצר ע״י"
            style={{ textAlign: 'right' }}
          />
          <Column
            field="createdAt"
            header="תאריך יצירה"
            style={{ textAlign: 'right' }}
            body={(rowData) =>
              rowData.createdAt
                ? new Date(rowData.createdAt).toLocaleDateString('he-IL') // Format date to 'dd/mm/yyyy' for Hebrew locale
                : ''
            }
          />
        </DataTable>

        {selectedService &&
          selectedService.map((serviceItem, index) => (
            <Chip
              key={serviceItem.id} // Adding a key for each Chip
              label={`${serviceItem.paymentServiceName}`}
              removable={true}
              onRemove={(a) => {
                setSelectedService(
                  selectedService.filter(
                    (_, serviceItemIndex) => serviceItemIndex !== index,
                  ),
                );
              }}
              style={{ marginLeft: '8px', marginTop: '8px' }}
            />
          ))}

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'left',
            marginTop: '20px',
            paddingBottom: '10px',
          }}
        >
          <CancelButton
            onClick={() => {
              closeDialog();
            }}
          />

          <div style={{ width: '10px' }} />
          <ApproveButtons isLoading={loading} onClick={handleApprove} />
        </div>
      </div>
    );
  });
